// extracted by mini-css-extract-plugin
export default {"root":"bzNj5BgqN87gHyJD","categoryDetails":"d183onaN1OUIEI0_","categorySelect":"oUC2K9u4gWkFrxkx","warning":"P5SwJY8oRDMIIaxJ"};